export enum TDateFieldType {
  MinMaxDate,
  MyPlanPurchaseDate,
  MyPlanDeliveryDate,
}
